import type { QueryHookOptions, QueryResult } from '@apollo/client';
import type { GetExamCommentsQuery, GetExamCommentsQueryVariables } from 'generated/graphql';

import { useQuery } from '@apollo/client';
import { EXAM_COMMENTS } from 'modules/Apollo/queries';

export const useExamCommentsQuery = (
  worklistItemSmid: string,
  options?: QueryHookOptions<GetExamCommentsQuery, GetExamCommentsQueryVariables>
): QueryResult<GetExamCommentsQuery, GetExamCommentsQueryVariables> => {
  const { fetchPolicy: fetchPolicyOption, context: contextOption, ...restOptions } = options ?? {};
  const fetchPolicyFinal = fetchPolicyOption ?? 'network-only';
  const context = contextOption ?? {};

  return useQuery<GetExamCommentsQuery, GetExamCommentsQueryVariables>(EXAM_COMMENTS, {
    ...restOptions,
    variables: { worklistItemSmid },
    fetchPolicy: fetchPolicyFinal,
    context: {
      ...context,
      telemetry: { ...context.telemetry, fetchPolicy: fetchPolicyFinal },
    },
  });
};
